<template>
    <div id="inform-key">
        <div class="sectionHeader isFixed" ref="mainHeader" v-if="mShowHeader">
            <div class="">
                <mainHeader class="mainHeader"></mainHeader>
            </div>
        </div>
        <div class="headerIsShow" v-if="mShowHeader"></div>
        <div class="i-back">
            <span class="lable-title m-left">消息中心</span>
            <span class="lable-time m-right" @click="back()">返回上一页></span>
        </div>
        <div class="i-space"></div>
        <van-pull-refresh v-show="!mNoAnyData" v-model="mIsRefresh" success-text="刷新成功" @refresh="onRefresh">
            <van-list v-model="mIsLoadMore" :offset="250" :immediate-check="false" :finished="mNoLoadMoreData"
                finished-text="没有更多了" @load="onLoadMore" :error.sync="mLoadMoreError">
                <div class="i-item" v-for="(item,index) in mMsgList" :key="index" @click="itemClick(item,index)">
                    <div class="i-line1">
                        <span class="lable-title m-left">系统通知</span>
                        <span class="lable-time m-right">{{callTime(item.create_time)}}</span>
                    </div>
                    <div class="i-line2 m-top m-left m-right">{{item.text}}</div>
                    <!-- <div class="i-line3 m-top m-left" v-if="item.msg_type === 1">查看详情></div> -->
                    <div class="i-x m-left"></div>
                </div>
            </van-list>
        </van-pull-refresh>
        <div class="i-empty" v-if="mNoAnyData">暂无数据</div>
    </div>
</template>

<script>
import { Toast } from 'mint-ui'
import mainHeader from '@/view/header'
export default {
    components: { mainHeader },
    data () {
        return {
            mShowHeader: true,
            mMsgList: [],
            mPageNo: 1, // 当前页码
            mPageSize: 10, // 一页显示的个数
            mState: 0, // 0：表示下拉刷新；1：表示加载更多
            mIsRefresh: false,
            mIsLoadMore: false,
            mNoAnyData: false,
            mNoLoadMoreData: false,
            mLoadMoreError: false,
        }
    },
    methods: {
        back: function() {
            this.$router.back(-1)
        },
        itemClick: function(item,index) {
            this.$router.push({
                path: '/informDetail',
                query: {
                    id: item.id
                }
            })
        },
        onRefresh: function() {
            this.mPageNo = 1
            this.mState = 0
            this.getListData()
        },
        onLoadMore: function() {
            this.mPageNo ++
            this.mState = 1
            this.getListData()
        },
        getListData: function() {
            const that = this
            let url = this.companyUrl + "/message/view?page=" + this.mPageNo + "&rows=" + this.mPageSize
            this.utils.POST(url, "", (resultData) => {
                that.callResulData(resultData)
            })
        },
        callResulData: function(resultData) { // 处理reusltData
            if (resultData.success) { // 请求成功
                const list = resultData.data.rows
                if (this.mState === 0) { // 下拉刷新
                    this.mIsRefresh = false
                    if (list === null || list.length <= 0) {
                        this.mNoAnyData = true
                        Toast('暂无数据')
                    } else {
                        this.mNoAnyData = false
                        this.mNoLoadMoreData = false
                        this.mMsgList = list
                    }
                } else if (this.mState === 1) { // 加载更多
                    this.mIsLoadMore = false
                    if (list === null || list.length <= 0) {
                        this.mNoLoadMoreData = true
                    } else {
                        this.mNoLoadMoreData = false
                        this.mMsgList = this.mMsgList.concat(list)
                    }
                    if (this.mLoadMoreError) {
                        this.mLoadMoreError = false
                    }
                }
            } else {
                Toast('网络不给力啊，再试一次吧！')
                if (this.mState === 0) { // 下拉刷新
                    this.mIsRefresh = false
                } else if (this.mState === 1) { // 加载更多
                    this.mLoadMoreError = true
                    this.mPageNo --
                }
            }
        },
        callTime: function(time) {
            if (time === undefined || time === NaN || time === null) {
                return ''
            }
            var nowDate = new Date()
            var msgDate = new Date(time)

            var nowTime = nowDate.getTime() // 当前时间戳
            var msgTime = msgDate.getTime()

            var dateDiff = nowTime - msgTime
            // 计算出相差天数
            var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); 
            var leave1 = dateDiff % (24 * 3600 * 1000); // 计算天数后剩余的毫秒数
            var hours = Math.floor(leave1 / (3600 * 1000)); // 计算出小时数
            // 计算相差分钟数
            var leave2 = leave1 % (3600 * 1000); // 计算小时数后剩余的毫秒数
            var minutes = Math.floor(leave2 / (60 * 1000)); // 计算相差分钟数
            // 计算相差秒数
            var leave3 = leave2 % (60 * 1000); // 计算分钟数后剩余的毫秒数
            var seconds = Math.round(leave3 / 1000);
            // console.log("相差" + dayDiff + "天" + hours + "小时" + minutes + "分钟" + seconds + "秒");
            var newTime = time.toString()
            if (dayDiff <= 0) {
                var todayNum = nowDate.getFullYear() + nowDate.getUTCMonth() + nowDate.getUTCDate()
                var msgNum = msgDate.getFullYear() + msgDate.getUTCMonth() + msgDate.getUTCDate()
                if (todayNum === msgNum) {
                    return newTime.substring(newTime.indexOf(' '), newTime.lastIndexOf(':'))
                } else {
                    return "昨天" + newTime.substring(newTime.indexOf(' '), newTime.lastIndexOf(':'))
                }
            } else {
                return newTime
            }
        }
    },
    created () {
        if (this.$route.query.isApp == 1 && this.$route.query.type == 1) {
            localStorage.setItem('enterType', this.$route.query.type)
            localStorage.setItem('isApp', this.$route.query.isApp)
        }
        if (this.$route.query.isApp == 1 || localStorage.getItem('isApp') == 1) {
            this.mShowHeader = false
        } else {
            this.mShowHeader = true
        }
        console.log(this.mShowHeader)
    },
    beforeCreate () {
      document.querySelector('body').setAttribute('style', 'background-color:#f2f2f2;')
    },
    mounted () {
        this.onRefresh()
    }
}
</script>

<style lang="scss" scoped>
    .sectionHeader {
        height: 55px;
        width: 100%;
        z-index: 900;
    }
    .sectionHeader.isFixed {
        position: fixed;
        top: 0px;
        height: 55px;
        width: 100%;
        z-index: 900;
    }
    .headerIsShow {
        margin-top: 55px;
    }
    .m-top {
        margin-top: 5px;
    }
    .m-left {
        margin-left: 13px;
    }
    .m-right {
        margin-right: 13px;
    }
    .i-back {
        height: 50px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background-color: #ffffff;
    }
    .lable-title {
        color: #000000;
        font-size: 16px;
        font-weight: bold;
    }
    .lable-time {
        color: #808080;
        font-size: 12px;
    }
    .i-space {
        height: 15px;
        background-color: #f2f2f2;
        width: 100%;
    }
    .i-item {
        position: relative;
        display: flex;
        flex-direction: column;
        padding-top: 13px;
        background-color: #ffffff;
        .i-line1 {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }
        .i-line2 {
            color: #808080;
            font-size: 14px;
            /* 多行显示省略号 */
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
        .i-line3 {
            color: #c41335;
            font-size: 12px;
        }
        .i-x {
            height: 1.2px;
            background-color: #f2f2f2;
            margin-top: 15px;
        }
    }
    .i-empty {
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #808080;
        font-size: 13px;
        background-color: #f2f2f2;
    }
</style>


// WEBPACK FOOTER //
// src/view/procurement/informList.vue